


























































import { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config';

import Vue from 'vue';

import { mapGetters } from 'vuex';

import { ColorEnum, DeviceEnum } from '../../enums';
import { RegularFilter } from '../../models';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

import Badge from '../badge.component.vue';
import { UiButton, UiIconButton, UiModal, UiSelect, UiTextbox } from '../keen-ui';
import EditAttributeForm from './edit-attribute-form.component.vue';

export default {
  name: 'attribute-entry',
  components: {
    EditAttributeForm,
    Badge,
    UiButton,
    UiIconButton,
    UiModal,
    UiSelect,
    UiTextbox
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    fieldNameOptions: function (): any[] {
      return this.instanceConfig.catalog.fields.reduce((fieldNameOptions: any[], fieldConfig: CatalogFieldConfig) => {
        if (fieldConfig.rankable) {
          fieldNameOptions.push({
            value: fieldConfig.id,
            label: (fieldConfig.prettyName || fieldConfig.id)
          });
        }
        return fieldNameOptions;
      }, []);
    },
    editButtonProps: function () {
      return {
        icon: 'edit',
        size: 'small',
        type: 'primary',
        color: ColorEnum.PRIMARY,
        raised: true
      };
    },
    scheduleText: function (): string {
      const scheduleTextItems: string[] = [];
      Object.keys(this.element.schedule).forEach((key) => {
        if (!!this.element.schedule[key]) {
          const dateString = this.$epb.utils.compileMessage(this.messages.fields.schedule.states[key], {
            date: this.getDateString(this.element.schedule[key])
          });
          scheduleTextItems.push(dateString);
        }
      });
      return !!scheduleTextItems.length ? scheduleTextItems.join('<br>') : this.messages.fields.schedule.states.always;
    }
  },
  data: function () {
    return {
      DeviceEnum
    };
  },
  props: {
    action: String,
    messages: Object,
    element: Object
  },
  methods: {
    getDateString: function (date: Date): string {
      const options: any = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      return date.toLocaleString(this.$epb.locale, options);
    },
    onFiltersUpdate: function (updates: any): void {
      Object.values(updates.filters).map((filter: RegularFilter) => {
        const filterId = (filter.config.toolingId || filter.config.id);
        if (!!filter.selectedValues.length) {
          Vue.set(this.element.filters, filterId, filter.selectedValues);
        } else {
          Vue.delete(this.element.filters, filterId);
        }
      });
      this.element.schedule = updates.schedule;
      this.$emit('updateFilters', this.element);
    }
  }
};

